export default __webpack_public_path__ + "static/media/Mark-3-HUD-Registration Marks.2c544ce2.jpg";